module.exports = __webpack_public_path__ + "static/media/ly.7722cf0c.svg";